import { all } from 'redux-saga/effects';
import playerSaga from './playerSaga';
import brandSaga from './brandSaga';
import brandSettingSaga from './brandSettingSaga';
import notificationSaga from './notificationSaga';
import templateSaga from './templateSaga';

import gameSaga from './gameSaga';
import promoCodeSaga from './promoCodeSaga';
import bonusSaga from './bonusSaga';
import cashBackSaga from './cashBackSaga';
import referralSaga from './referralSaga';
import tagSaga from './tagSaga';
import brandPaymentSaga from './brandPaymentSaga';
import reportingSaga from './reportingSaga';
import operatorLimitSaga from './operatorLimitSaga';
import legalAgreementSaga from './legalAgreementSaga';
import accountUpdatesSaga from './accountUpdatesSaga';
import cashierSaga from './cashierSaga';
import playerPerformanceSaga from './playerPerformanceSaga';
import overviewSaga from './overviewSaga';
import previousAccount from './previousAccountSaga';
import campaignSaga from './campaignSaga';
import taxesSaga from './taxesSaga';
import brandMarketSaga from './brandMarketSaga';
import exportCenterSaga from './exportCenterSaga';
import playerWalletSaga from './playerWalletSaga';
import playerSession from './playerSessionSaga';
import campaignV2 from './campaignV2Saga';
import userActions from './userActionsSaga';
import superiorCountries from './superiorCountriesSaga';

export default function* rootSaga() {
  yield all([
    playerSaga(),
    brandSaga(),
    brandSettingSaga(),
    brandMarketSaga(),
    notificationSaga(),
    templateSaga(),
    gameSaga(),
    promoCodeSaga(),
    bonusSaga(),
    cashBackSaga(),
    referralSaga(),
    tagSaga(),
    brandPaymentSaga(),
    reportingSaga(),
    operatorLimitSaga(),
    legalAgreementSaga(),
    accountUpdatesSaga(),
    cashierSaga(),
    playerPerformanceSaga(),
    overviewSaga(),
    previousAccount(),
    campaignSaga(),
    taxesSaga(),
    exportCenterSaga(),
    playerWalletSaga(),
    playerSession(),
    campaignV2(),
    userActions(),
    superiorCountries(),
  ]);
}
